export const SET_POS = 'SET_POS'
export const ADD_PO = 'ADD_PO'
export const UPDATE_PO = 'UPDATE_PO'
export const DELETE_PO = 'DELETE_PO'
export const DELETE_MULTIPLE_POS = 'DELETE_MULTIPLE_POS'
export const SET_SELECTED_POS = 'SET_SELECTED_POS'
export const SET_TOTAL_POS = 'SET_TOTAL_POS'
export const RESET_SUPPLIER = 'RESET_SUPPLIER'
export const RESET_ITEM = 'RESET_ITEM'
export const SET_SUPPLIER = 'SET_SUPPLIER'
export const SET_ITEM = 'SET_ITEM'
export const SET_TEMPLATE_ID = 'SET_TEMPLATE_ID'
export const SELECT_SUPPLIER = 'SELECT_SUPPLIER'
export const RESET_SELECTED_SUPPLIER = 'RESET_SELECTED_SUPPLIER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const RESET_SELECTED_POS = 'RESET_SELECTED_POS'
export const UPDATE_PO_STATUS = 'UPDATE_PO_STATUS'
export const SET_PO_FOR_DELIVERYNOTES = 'SET_PO_FOR_DELIVERYNOTES'
export const SET_PO_FOR_INVOICES = 'SET_PO_FOR_INVOICES'
export const RESET_PO_FOR_INVOICES = 'RESET_PO_FOR_INVOICES'